import React, { useCallback, useContext } from 'react';

import { BuildingsFloorsPartsContext } from '../../buildings-floors-parts.context';
import BuildingsFloorPartForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(BuildingsFloorsPartsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <BuildingsFloorPartForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
